/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Divider } from '@gasbuddy/react-components';
import { RepliesType } from '../../../utils/prop-types/review-types';
import sharedStyles from '../../../styles/shared.css';
import styles from './styles.css';
import BrandPropType from '../../../utils/prop-types/brand';

const MISSING_BRAND_LOGO = '/images/stationProfile/v2/review/owner-icon.png';
const STATION_OWNER_ICON = '/images/stationProfile/v2/review/owner-icon.png';
const STATION_OWNER = 'Station Owner';

class ReviewReplyList extends React.Component {
  static propTypes = {
    reviewId: PropTypes.number.isRequired,
    replies: PropTypes.arrayOf(RepliesType).isRequired,
    brandsMap: PropTypes.shape({
      brandId: BrandPropType,
    }).isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      replies: this.props.replies,
    };
  }

  componentDidUpdate = (prevProps) => {
    const { replies } = this.props;

    if (!_.isEqual(this.props.replies, prevProps.replies)) {
      this.setState(() => ({ replies }));
    }
  }

  render = () => {
    const { reviewId, brandsMap } = this.props;
    const { replies } = this.state;

    return (
      <div className={styles.replyListContainer}>
        {replies.map((reply) => {
          if (reply.author_info.author_name === STATION_OWNER) {
            reply.author_info.author_logo_url = STATION_OWNER_ICON;
          } else {
            const replyBrand = brandsMap[reply.brand_id];
            reply.author_info.author_logo_url = replyBrand ? replyBrand.image_url : MISSING_BRAND_LOGO;
          }
          return (
            <span key={`${reviewId}-${reply.create_date}`}>
              <Divider className={styles.extendingLine} />
              <div>
                <div className={styles.brandLogo}>
                  <img src={reply.author_info.author_logo_url} alt="" />
                </div>
                <div className={sharedStyles.pullLeft}>
                  <div className={styles.brandName}>{reply.author_info.author_name}</div>
                  <div>
                    {`${moment(reply.create_date).format('MMM DD, YYYY [at] hh:mma')} - Review ID # ${reviewId}`}
                  </div>
                </div>
                <div className="clearfix" />
              </div>
              <Divider />
              <div>{reply.text}</div>
            </span>
          );
        })}
      </div>
    );
  }
}

export default ReviewReplyList;
